import $ from 'jquery';


const createCartMutation = `mutation createCart($cartInput: CartInput) {
  cartCreate(input: $cartInput) {
    cart {
      id
      checkoutUrl
      lines(first: 10) {
        edges {
          node {
            id
            merchandise {
              ... on ProductVariant {
                id
                title
              }
            }
          }
        }
      }
      cost {
        totalAmount {
          amount
          currencyCode
        }
      }
    }
  }
}`;

export function getStoreURL() {
    return $('[name="shopify_url"]').val();
}

// See https://shopify.dev/docs/api/storefront/2025-10/mutations/cartcreate
export async function createCart(variables) {
    return $.ajax({
        type: 'POST',
        url: `${getStoreURL()}/api/2025-10/graphql.json`,
        dataType: 'json',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'query': createCartMutation,
            'variables': variables,
        }),
        contentType: 'application/json',
    });

}